export default __webpack_public_path__ + "static/media/instagram.e098cb43.svg";